import { ref, watch } from 'vue';
import { currentTheme } from '@/ui/tokens/themes';

export const NEW_YEAR_THEME_ID = 'newyear';
const PREVIOUS_THEME_KEY = 'newYearPreviousTheme';
const SEASON_FORCED = localStorage.getItem('newYearSeason') === 'on';

const seasonYear = date => (date.getMonth() === 0 ? date.getFullYear() - 1 : date.getFullYear());

export function seasonRange(date) {
  const year = seasonYear(date);
  return { start: new Date(year, 11, 1), end: new Date(year + 1, 0, 14) };
}

export function isNewYearSeason(date) {
  const year = seasonYear(date);
  return SEASON_FORCED || (date >= new Date(year, 11, 1) && date < new Date(year + 1, 0, 15));
}

export const isDevforthUser = user => user.email.endsWith('@devforth.io');

export const previousThemeId = () => localStorage.getItem(PREVIOUS_THEME_KEY);

watch(currentTheme, (id, prevId) => {
  if (id === NEW_YEAR_THEME_ID && prevId !== NEW_YEAR_THEME_ID) localStorage.setItem(PREVIOUS_THEME_KEY, prevId);
});

const LETTER_READ_KEY = `newYearLetterRead-${seasonYear(new Date())}`;

export const letterRead = ref(localStorage.getItem(LETTER_READ_KEY) === 'yes');

export function markLetterRead() {
  letterRead.value = true;
  localStorage.setItem(LETTER_READ_KEY, 'yes');
}
